import React from "react";
import { _t } from "../../../../../app/i18n/i18n";
import { formatInt } from "../../../../../lib/numberFormat";
import { ReportsPerPageDropdown } from "./ReportsPerPageDropdown";

export const NumberOfSearchResults = ({ number, className = "" }) =>
  number ? (
    <footer className={"text-muted mb-1 bg-none d-none d-md-block " + className}>
      <small>
        {_t("numResultsMsg1") + formatInt(number) + _t("numResultsMsg2")}
        <ReportsPerPageDropdown />
        {_t("numResultsMsg3")}
      </small>
    </footer>
  ) : null;
